import { Settings, Palette, User, Building2, Activity } from 'lucide-react';
import { useTenant } from '@/context/TenantContext';
import { useAuth } from '@/context/AuthContext';
import { useGet } from '@/lib/useData';
import { PageHeader } from '@/components/common/PageHeader';
import { SectionCard } from '@/components/common/SectionCard';
import { Badge } from '@/components/ui/badge';

export default function Parametres() {
  const { association } = useTenant();
  const { user, isAdmin } = useAuth();
  const health = useGet('/sync/health', undefined, true);

  return (
    <div className="space-y-6">
      <PageHeader title="Paramètres" icon={Settings} subtitle={isAdmin ? 'Identité, compte et connexions' : 'Identité et compte'} />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <SectionCard title="Identité de l'association" subtitle={isAdmin ? 'Modifiable depuis l\'Administration' : 'Gérée par SHARITI'}>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl font-display text-xl font-bold text-white" style={{ background: association?.primary_color || '#0B7A75' }}>
              {(association?.name || 'SH').slice(0, 2).toUpperCase()}
            </div>
            <div>
              <p className="font-display text-lg font-semibold">{association?.name}</p>
              <p className="text-sm text-muted-foreground">{association?.tagline}</p>
              <div className="mt-2 flex items-center gap-2">
                <span className="h-4 w-4 rounded-full border" style={{ background: association?.primary_color }} />
                <span className="font-mono text-xs text-muted-foreground">{association?.primary_color}</span>
              </div>
            </div>
          </div>
        </SectionCard>

        <SectionCard title="Mon compte">
          <div className="space-y-3">
            <Row icon={User} label="Nom" value={user?.name} />
            <Row icon={Building2} label="Email" value={user?.email} />
            <Row icon={Settings} label="Rôle" value={user?.role === 'SHARITI_ADMIN' ? 'Administrateur SHARITI' : 'Utilisateur association'} />
          </div>
        </SectionCard>

        {isAdmin && (
        <SectionCard title="Connexion Evergiving" subtitle="Source de données officielle" className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className={`flex h-11 w-11 items-center justify-center rounded-2xl ${health.data?.ok ? 'bg-emerald-50' : 'bg-rose-50'}`}>
              <Activity className={`h-5 w-5 ${health.data?.ok ? 'text-emerald-600' : 'text-rose-600'}`} />
            </div>
            <div>
              <p className="font-display text-sm font-semibold">{health.data?.ok ? 'API connectée' : 'API indisponible'}</p>
              <p className="text-xs text-muted-foreground">{health.data?.note || 'Vérification…'}</p>
            </div>
            <Badge variant="secondary" className="ml-auto rounded-full">{health.data?.state || '…'}</Badge>
          </div>
        </SectionCard>
        )}
      </div>
    </div>
  );
}

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3">
    <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-muted"><Icon className="h-4 w-4 text-muted-foreground" /></div>
    <div><p className="text-xs text-muted-foreground">{label}</p><p className="text-sm font-medium">{value || '—'}</p></div>
  </div>
);
